
export const get_dog_breeds = () => {
  return [
    'Unknown',
    'Australian Shepherd',
    'American Cocker Spaniel',
    'Akita',
    'Australian Cattle Dog',
    'Alaskan Malamute',
    'Airedale Terrier',
    'American Staffordshire Terrier',
    'Anatolian Shepherd Dog',
    'Afghan Hound',
    'American Eskimo Dog',
    'American Hairless Terrier',
    'Australian Terrier',
    'Affenpinscher',
    'American Water Spaniel',
    'American English Coonhound',
    'American Foxhound',
    'Africanis',
    'Aidi',
    'Akbash Dog',
    'Alano Espanol',
    'Alapaha Blue Blood Bulldog',
    'Alaskan Klee Kai',
    'American Pit Bull Terrier',
    'American Staghound',
    'American White Shepherd',
    'Appenzeller Sennenhund',
    'Argentine Dogo',
    'Ariege Pointer',
    'Ariegeois',
    'Australian Bulldog',
    'Australian Kelpie',
    'Australian Stumpy Tail Cattle Dog',
    'Austrian Black and Tan Hound',
    'Austrian Pinscher',
    'Azawakh',
    'Alaskan Husky',
    'Alopekis',
    'American Bulldog',
    'Andalusian Hound',
    'American Mastiff',
    'Bulldog',
    'Beagle',
    'Boxer',
    'Boston Terrier',
    'Bernese Mountain Dog',
    'Brittany',
    'Border Collie',
    'Basset Hound',
    'Belgian Malinois',
    'Bichon Frise',
    'Bloodhound',
    'Bullmastiff',
    'Bull Terrier',
    'Bouvier des Flandres',
    'Basenji',
    'Border Terrier',
    'Brussels Griffon',
    'Boykin Spaniel',
    'Borzoi',
    'Belgian Tervuren',
    'Black Russian Terrier',
    'Boerboel',
    'Beauceron',
    'Belgian Sheepdog',
    'Bearded Collie',
    'Bluetick Coonhound',
    'Briard',
    'Black and Tan Coonhound',
    'Bedlington Terrier',
    'Berger Picard',
    'Bergamasco',
    'Barbet',
    'Basset Bleu de Gascogne',
    'Basset Fauve de Bretagne',
    'Bavarian Mountain Hound',
    'Belgian Shepherd Laekenois',
    'Black Mouth Cur',
    'Black Norwegian Elkhound',
    'Blue Lacy',
    'Blue Picardy Spaniel',
    'Bohemian Shepherd',
    'Bouvier des Ardennes',
    'Bracco Italiano',
    'Braque du Bourbonnais',
    'Brazilian Terrier',
    'Briquet Griffon Vendeen',
    'Bukovina Sheepdog',
    'Bulgarian Shepherd Dog',
    'Basset Artesien Normand',
    'Beagle-Harrier',
    'Beaglier',
    'Bolognese dog',
    'Bull Arab',
    'Broholmer',
    'Biewer Terrier',
    'Cane Corso',
    'Chihuahua',
    'Collie',
    'Cavalier King Charles Spaniel',
    'Chesapeake Bay Retriever',
    'Cardigan Welsh Corgi',
    'Cairn Terrier',
    'Chow Chow',
    'Chinese Crested',
    'Coton De Tulear',
    'Clumber Spaniel',
    'Curly-Coated Retriever',
    'Canaan Dog',
    'Cirneco dell\'Etna',
    'Cesky Terrier',
    'Chinook',
    'Serra de Aires dog',
    'Canadian Eskimo Dog',
    'Caravan Hound',
    'Carolina Dog',
    'Carpathian Sheepdog',
    'Catahoula Bulldog',
    'Catahoula Leopard Dog',
    'Catalan Sheepdog',
    'Caucasian Ovcharka',
    'Central Asian Ovtcharka',
    'Cesky Fousek',
    'Chart Polski',
    'Cockapoo',
    'Croatian Sheepdog',
    'Czechoslovakian Wolfdog',
    'Chippiparai',
    'Chizer',
    'Cotonese',
    'Cairmal',
    'Chorkie',
    'Cockalier',
    'Dachshund',
    'Doberman Pinscher',
    'Dalmatian',
    'Dogue de Bordeaux',
    'Danish-Swedish Farmdog',
    'Deutsche Bracke',
    'Dingo',
    'Dandie Dinmont Terrier',
    'Drentse Patrijshond',
    'Drever',
    'Dunker',
    'Dutch Shepherd Dog',
    'Dutch Smoushond',
    'Dorgi',
    'Dorkie',
    'Double Doodle',
    'English Springer Spaniel',
    'English Cocker Spaniel',
    'English Setter',
    'English Toy Spaniel',
    'Entlebucher Mountain Dog',
    'English Foxhound',
    'East Siberian Laika',
    'East-European Shepherd',
    'English Shepherd',
    'Eurasier',
    'French Bulldog',
    'Flat-Coated Retriever',
    'Field Spaniel',
    'Finnish Lapphund',
    'Finnish Spitz',
    'Fila Brasileiro',
    'Finnish Hound',
    'French Spaniel',
    'Francais Blanc et Noir',
    'German Shepherd',
    'Golden Retriever',
    'German Shorthaired Pointer',
    'Great Dane',
    'German Wirehaired Pointer',
    'Great Pyrenees',
    'Greater Swiss Mountain Dog',
    'Giant Schnauzer',
    'Gordon Setter',
    'German Pinscher',
    'Greyhound',
    'Glen of Imaal Terrier',
    'Grand Basset Griffon Vendeen',
    'Grand Bleu de Gascogne',
    'German Longhaired Pointer',
    'Goldendoodle',
    'Greenland Dog',
    'Griffon bleu de Gascogne',
    'Havanese',
    'Harrier',
    'Hamilton Hound',
    'Hokkaido Dog',
    'Hovawart',
    'Italian Greyhound',
    'Irish Wolfhound',
    'Irish Setter',
    'Irish Terrier',
    'Irish Red and White Setter',
    'Ibizan Hound',
    'Icelandic Sheepdog',
    'Irish Water Spaniel',
    'Jack Russell Terrier',
    'Japanese Chin',
    'Jagdterrier',
    'Jamthund',
    'Japanese Spitz',
    'Japanese Terrier',
    'Keeshond',
    'Kerry Blue Terrier',
    'Kooikerhondje',
    'Kuvasz',
    'Komondor',
    'Kangal Dog',
    'Korean Jindo',
    'Karelian Bear Dog',
    'Kishu Ken',
    'Koolie',
    'Kromfohrlander',
    'Karst Shepherd',
    'King Shepherd',
    'Kyi-Leo',
    'Labrador Retriever',
    'Lhasa Apso',
    'Leonberger',
    'Lagotto Romagnolo',
    'Lakeland Terrier',
    'Lowchen',
    'Large Munsterlander',
    'Lancashire Heeler',
    'Landseer',
    'Lapponian Herder',
    'Lucas Terrier',
    'Lurcher',
    'Miniature Schnauzer',
    'Mastiff',
    'Miniature American Shepherd',
    'Maltese',
    'Miniature Pinscher',
    'Miniature Bull Terrier',
    'Manchester Terrier',
    'Miniature Poodle',
    'Miniature Shar Pei',
    'McNab',
    'Miniature Bulldog',
    'Mudi',
    'Mountain Feist',
    'Majestic Tree Hound',
    'Maremma Sheepdog',
    'Mal-Shi',
    'Mountain Cur',
    'Newfoundland',
    'Nova Scotia Duck Tolling Retriever',
    'Norwegian Elkhound',
    'Neapolitan Mastiff',
    'Norwich Terrier',
    'Norfolk Terrier',
    'Norwegian Buhund',
    'Norwegian Lundehund',
    'New Guinea Singing Dog',
    'Norrbottenspets',
    'Northern Inuit Dog',
    'Moscow Watchdog',
    'Old English Sheepdog',
    'Otterhound',
    'Olde English Bulldogge',
    'Poodle',
    'Pembroke Welsh Corgi',
    'Pomeranian',
    'Pug',
    'Portuguese Water Dog',
    'Papillon',
    'Pekingese',
    'Pointer',
    'Parson Russell Terrier',
    'Pumi',
    'Portuguese Podengo Pequeno',
    'Petit Basset Griffon Vendeen',
    'Puli',
    'Polish Lowland Sheepdog',
    'Plott Hound',
    'Pharaoh Hound',
    'Polish Hunting Dog',
    'Pakistani Mastiff',
    'Patterdale Terrier',
    'Pyrenean Shepherd',
    'Perro de Presa Canario',
    'Perro de Presa Mallorquin',
    'Peruvian Inca Orchid',
    'Picardy Spaniel',
    'Plummer Terrier',
    'Portuguese Pointer',
    'Prazsky Krysarik',
    'Pudelpointer',
    'Pont-Audemer Spaniel',
    'Pyrenean Mastiff',
    'Polish Tatra Sheepdog',
    'Rottweiler',
    'Rhodesian Ridgeback',
    'Rat Terrier',
    'Redbone Coonhound',
    'Rafeiro do Alentejo',
    'Rajapalayam dog',
    'Russian Spaniel',
    'Russian Toy',
    'Mioritic Shepherd Dog',
    'Russian Tsvetnaya Bolonka',
    'Siberian Husky',
    'Shih Tzu',
    'Shetland Sheepdog',
    'Shiba Inu',
    'St. Bernard',
    'Soft Coated Wheaten Terrier',
    'Scottish Terrier',
    'Samoyed',
    'Shar-Pei',
    'Staffordshire Bull Terrier',
    'Standard Schnauzer',
    'Schipperke',
    'Spinone Italiano',
    'Silky Terrier',
    'Saluki',
    'Smooth Fox Terrier',
    'Spanish Water Dog',
    'Scottish Deerhound',
    'Sealyham Terrier',
    'Swedish Vallhund',
    'Skye Terrier',
    'Sussex Spaniel',
    'Sloughi',
    'Spanish Greyhound',
    'Small Munsterlander',
    'Saarloos wolfdog',
    'Sapsali',
    'Sarplaninac',
    'Schapendoes',
    'Seppala Siberian Sleddog',
    'Shikoku dog',
    'Shiloh Shepherd dog',
    'Silken Windhound',
    'Smaland Hound',
    'South Russian Ovcharka',
    'Spanish Mastiff',
    'Serbian Hound',
    'Swedish Lapphund',
    'Shichon',
    'Slovensky Cuvac',
    'Stabyhoun',
    'Tibetan Terrier',
    'Toy Fox Terrier',
    'Tibetan Spaniel',
    'Tibetan Mastiff',
    'Treeing Walker Coonhound',
    'Toy Poodle',
    'Tamaskan Dog',
    'Thai Bangkaew Dog',
    'Thai Ridgeback',
    'Tornjak',
    'Tosa Ken',
    'Transylvanian Hound',
    'Texas Heeler',
    'Taco Terrier',
    'Vizsla',
    'Volpino Italiano',
    'Weimaraner',
    'West Highland White Terrier',
    'Whippet',
    'Wirehaired Pointing Griffon',
    'Wire Fox Terrier',
    'Welsh Terrier',
    'Welsh Springer Spaniel',
    'Wirehaired Vizsla',
    'West Siberian Laika',
    'Wetterhoun',
    'Xoloitzcuintli',
    'Yorkshire Terrier'
  ];
};


export const get_cat_breeds = () => {
  return [
    'Unknown',
    'Abyssinian',
    'American Bobtail',
    'American Curl',
    'American Shorthair',
    'American Wirehair',
    'Anatolian',
    'Angora/Turkish Angora',
    'Asian Semi-Longhair/Tiffanie',
    'Asian Shorthair',
    'Australian Mist/Spotted Mist',
    'Balinese-Javanese',
    'Bengal',
    'Birman',
    'Bombay',
    'Brazilian Shorthair',
    'British Angora/Oriental Longhair',
    'British Shorthair',
    'Burmese',
    'Burmilla',
    'California Spangled Cat',
    'Chantilly/Tiffany',
    'Chartreux',
    'Chausie',
    'Cherubim/Honeybear',
    'Colorpoint Shorthair',
    'Cornish Rex',
    'German Rex',
    'Cymric',
    'Devon Rex',
    'Domestic long-hair (non-pedigreed)',
    'Domestic medium-hair (non-pedigreed)',
    'Domestic short-hair (non-pedigreed)',
    'Don Hairless',
    'Egyptian Mau',
    'European Burmese',
    'European Shorthair',
    'Exotic Shorthair',
    'Havana Brown',
    'Himalayan',
    'Japanese Bobtail',
    'Javanese',
    'Khao Manee',
    'Korat',
    'LaPerm',
    'Lykoi',
    'Maine Coon',
    'Malayan',
    'Manx',
    'Munchkin',
    'Nebelung',
    'Norwegian Forest',
    'Ocicat',
    'Ojos Azules',
    'Oriental',
    'Oriental Short Hair',
    'Persian',
    'Peterbald',
    'Pixiebob',
    'Ragamuffin',
    'Ragdoll',
    'Russian Blue',
    'Savannah',
    'Scottish Fold',
    'Selkirk Rex',
    'Siamese',
    'Siberian',
    'Singapura',
    'Snowshoe',
    'Sokoke',
    'Somali',
    'Sphynx',
    'Spotted Mist',
    'Sterling',
    'Tonkinese',
    'Toybob',
    'Toyger',
    'Traditional (Applehead) Siamese',
    'Turkish Angora',
    'Turkish Van',
    'York Chocolate'
  ];
};

